
const benefits = [
  {
    id: 1,
    title: 'Medical Visits',
    description: 'Access to quality healthcare providers and specialists with comprehensive coverage for routine checkups and medical consultations.',
    icon: 'ri-stethoscope-line'
  },
  {
    id: 2,
    title: 'Eye Care',
    description: 'Vision coverage including eye exams, glasses, and contact lenses to keep your eyesight sharp and healthy.',
    icon: 'ri-eye-line'
  },
  {
    id: 3,
    title: 'Dental',
    description: 'Complete dental coverage for preventive care, cleanings, and major dental procedures to maintain your oral health.',
    icon: 'ri-tooth-line'
  },
  {
    id: 4,
    title: 'Prescriptions',
    description: 'Affordable prescription drug coverage with access to a wide network of pharmacies for your medication needs.',
    icon: 'ri-capsule-line'
  }
];

const Benefits = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#2196F3] font-semibold text-sm uppercase tracking-wider">Coverage Benefits</span>
          <h3 className="text-3xl md:text-4xl font-bold text-[#0A2647] mt-3 mb-4">
            Make the Most of Your Healthcare
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Our comprehensive plans cover all aspects of your health, ensuring you and your family 
            have access to the care you need.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="text-center p-8 rounded-xl bg-gray-50 hover:bg-[#0A2647] group transition-all duration-300 cursor-pointer"
            >
              <div className="w-20 h-20 mx-auto mb-6 bg-[#2196F3]/10 group-hover:bg-white/10 rounded-2xl flex items-center justify-center transition-colors">
                <i className={`${benefit.icon} text-4xl text-[#2196F3] group-hover:text-white transition-colors`}></i>
              </div>
              <h4 className="text-xl font-bold text-[#0A2647] group-hover:text-white mb-3 transition-colors">
                {benefit.title}
              </h4>
              <p className="text-gray-600 group-hover:text-white/80 leading-relaxed transition-colors">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="tel:512-306-6245"
            className="inline-flex items-center gap-3 bg-[#0A2647] hover:bg-[#0A2647]/90 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill"></i>
            Speak With an Expert: 512-306-6245
          </a>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
